import { useEffect, useRef, useCallback } from "react";

export function useCursor() {
  const dotRef = useRef(null);
  const ringRef = useRef(null);
  const mouse = useRef({ x: 0, y: 0 });
  const ring = useRef({ x: 0, y: 0 });
  const rafRef = useRef(null);

  const animate = useCallback(() => {
    ring.current.x += (mouse.current.x - ring.current.x) * 0.14;
    ring.current.y += (mouse.current.y - ring.current.y) * 0.14;
    if (dotRef.current) {
      dotRef.current.style.left = mouse.current.x + "px";
      dotRef.current.style.top = mouse.current.y + "px";
    }
    if (ringRef.current) {
      ringRef.current.style.left = ring.current.x + "px";
      ringRef.current.style.top = ring.current.y + "px";
    }
    rafRef.current = requestAnimationFrame(animate);
  }, []);

  useEffect(() => {
    const onMove = (e) => {
      mouse.current.x = e.clientX;
      mouse.current.y = e.clientY;
    };
    const onEnter = () => {
      dotRef.current?.classList.add("hovered");
      ringRef.current?.classList.add("hovered");
    };
    const onLeave = () => {
      dotRef.current?.classList.remove("hovered");
      ringRef.current?.classList.remove("hovered");
    };

    window.addEventListener("mousemove", onMove);
    document.querySelectorAll("a, button, [data-hover]").forEach((el) => {
      el.addEventListener("mouseenter", onEnter);
      el.addEventListener("mouseleave", onLeave);
    });

    rafRef.current = requestAnimationFrame(animate);
    return () => {
      window.removeEventListener("mousemove", onMove);
      if (rafRef.current) cancelAnimationFrame(rafRef.current);
    };
  }, [animate]);

  return { dotRef, ringRef };
}
